module.exports = __webpack_public_path__ + "media/src/ui/images/iconBinWhite-873928e17e8ba4e5ffe9a15c226fa5ec.svg";